<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="preview-container">
  <h1>
    <a matIconButton color="primary" routerLink="/" style="margin-right: 15px">
      <mat-icon splUiIcon="home"></mat-icon>
    </a>

    Splitory Theme Preview
  </h1>

  <mat-card class="preview-container__colors">
    <mat-card-header>
      <mat-card-title>Colors</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <div class="color-preview-grid">
        @for (color of colors; track $index) {
          <ng-container *ngTemplateOutlet="colorPreview; context: color"></ng-container>
        }
      </div>
    </mat-card-content>

    <ng-template #colorPreview let-label="label" let-getHex="getHex">
      <div class="color-preview" matTooltip="Copy color hex" (click)="toClipBoard(getHex())">
        <div class="label">
          {{ label }}

          <div class="label-hex" [style.color]="getHex()">
            {{ getHex() }}
          </div>
        </div>

        <div class="color-box" [style.backgroundColor]="getHex()"></div>
      </div>
    </ng-template>
  </mat-card>

  <mat-card class="preview-container__buttons">
    <mat-card-header>
      <mat-card-title>Buttons</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <section>
        <div class="example-label">Text</div>
        <div class="example-button-row">
          <button matButton>Basic</button>
          <button matButton color="primary">Primary</button>
          <button matButton color="secondary">Secondary</button>
          <button matButton color="tertiary">Tertiary</button>
          <button matButton color="error">Error</button>
          <button matButton disabled>Disabled</button>
          <a matButton href="https://www.google.com/" target="_blank">
            <mat-icon splUiIcon="external-link"></mat-icon>
            Link
          </a>
        </div>
      </section>
      <mat-divider />
      <section>
        <div class="example-label">Elevated</div>
        <div class="example-button-row">
          <button matButton="elevated">Basic</button>
          <button matButton="elevated" color="primary">Primary</button>
          <button matButton="elevated" color="secondary">Secondary</button>
          <button matButton="elevated" color="tertiary">Tertiary</button>
          <button matButton="elevated" color="error">Error</button>
          <button matButton="elevated" disabled>Disabled</button>
          <a matButton="elevated" href="https://www.google.com/" target="_blank">
            <mat-icon splUiIcon="external-link"></mat-icon>
            Link
          </a>
        </div>
      </section>
      <mat-divider />
      <section>
        <div class="example-label">Outlined</div>
        <div class="example-button-row">
          <button matButton="outlined">Basic</button>
          <button matButton="outlined" color="primary">Primary</button>
          <button matButton="outlined" color="secondary">Secondary</button>
          <button matButton="outlined" color="tertiary">Tertiary</button>
          <button matButton="outlined" color="error">Error</button>
          <button matButton="outlined" disabled>Disabled</button>
          <a matButton="outlined" href="https://www.google.com/" target="_blank">
            <mat-icon splUiIcon="external-link"></mat-icon>
            Link
          </a>
        </div>
      </section>
      <mat-divider />
      <section>
        <div class="example-label">Filled</div>
        <div class="example-button-row">
          <button matButton="filled">Basic</button>
          <button matButton="filled" color="primary">Primary</button>
          <button matButton="filled" color="secondary">Secondary</button>
          <button matButton="filled" color="tertiary">Tertiary</button>
          <button matButton="filled" color="error">Error</button>
          <button matButton="filled" disabled>Disabled</button>
          <a matButton="filled" href="https://www.google.com/" target="_blank">
            <mat-icon splUiIcon="external-link"></mat-icon>
            Link
          </a>
        </div>
      </section>
      <mat-divider />
      <section>
        <div class="example-label">Tonal</div>
        <div class="example-button-row">
          <button matButton="tonal">Basic</button>
          <button matButton="tonal" color="primary">Primary</button>
          <button matButton="tonal" color="secondary">Secondary</button>
          <button matButton="tonal" color="tertiary">Tertiary</button>
          <button matButton="tonal" color="error">Error</button>
          <button matButton="tonal" disabled>Disabled</button>
          <a matButton="tonal" href="https://www.google.com/" target="_blank">
            <mat-icon splUiIcon="external-link"></mat-icon>
            Link
          </a>
        </div>
      </section>
      <mat-divider />
      <section>
        <div class="example-label">Icon</div>
        <div class="example-button-row">
          <div class="example-flex-container">
            <button matIconButton aria-label="Example icon button with a vertical three dot icon">
              <mat-icon splUiIcon="dots-vertical"></mat-icon>
            </button>
            <button matIconButton color="primary" aria-label="Example icon button with a vertical three dot icon">
              <mat-icon splUiIcon="dots-vertical"></mat-icon>
            </button>
            <button matIconButton color="secondary" aria-label="Example icon button with a vertical three dot icon">
              <mat-icon splUiIcon="dots-vertical"></mat-icon>
            </button>
            <button matIconButton color="tertiary" aria-label="Example icon button with a vertical three dot icon">
              <mat-icon splUiIcon="dots-vertical"></mat-icon>
            </button>
            <button matIconButton color="error" aria-label="Example icon button with a vertical three dot icon">
              <mat-icon splUiIcon="dots-vertical"></mat-icon>
            </button>
            <button matIconButton disabled aria-label="Example icon button with a open in new tab icon">
              <mat-icon splUiIcon="external-link"></mat-icon>
            </button>
          </div>
        </div>
      </section>
      <mat-divider />
      <section>
        <div class="example-label">Floating Action Button (FAB)</div>
        <div class="example-button-row">
          <div class="example-flex-container">
            <button matFab aria-label="Example icon button with a delete icon">
              <mat-icon splUiIcon="trash-filled"></mat-icon>
            </button>
            <button matFab color="primary" aria-label="Example icon button with a delete icon">
              <mat-icon splUiIcon="trash-filled"></mat-icon>
            </button>
            <button matFab color="secondary" aria-label="Example icon button with a delete icon">
              <mat-icon splUiIcon="trash-filled"></mat-icon>
            </button>
            <button matFab color="tertiary" aria-label="Example icon button with a delete icon">
              <mat-icon splUiIcon="trash-filled"></mat-icon>
            </button>
            <button matFab color="error" aria-label="Example icon button with a delete icon">
              <mat-icon splUiIcon="trash-filled"></mat-icon>
            </button>
            <button matFab disabled aria-label="Example icon button with a heart icon">
              <mat-icon splUiIcon="heart"></mat-icon>
            </button>
          </div>
        </div>
      </section>
      <mat-divider />
      <section>
        <div class="example-label">Extended FAB</div>
        <div class="example-button-row">
          <div class="example-flex-container">
            <button matFab extended>
              <mat-icon splUiIcon="heart"></mat-icon>
              Basic
            </button>
            <button matFab extended color="primary">
              <mat-icon splUiIcon="heart"></mat-icon>
              Primary
            </button>
            <button matFab extended color="secondary">
              <mat-icon splUiIcon="heart"></mat-icon>
              Secondary
            </button>
            <button matFab extended color="tertiary">
              <mat-icon splUiIcon="heart"></mat-icon>
              Tertiary
            </button>
            <button matFab extended color="error">
              <mat-icon splUiIcon="heart"></mat-icon>
              Error
            </button>
            <button matFab extended disabled>
              <mat-icon splUiIcon="heart"></mat-icon>
              Disabled
            </button>
            <a matFab extended routerLink=".">
              <mat-icon splUiIcon="external-link"></mat-icon>
              Link
            </a>
          </div>
        </div>
      </section>
      <mat-divider />
      <section>
        <div class="example-label">Mini FAB</div>
        <div class="example-button-row">
          <div class="example-flex-container">
            <button matMiniFab aria-label="Example icon button with a menu icon">
              <mat-icon splUiIcon="menu-2"></mat-icon>
            </button>
            <button matMiniFab color="primary" aria-label="Example icon button with a menu icon">
              <mat-icon splUiIcon="menu-2"></mat-icon>
            </button>
            <button matMiniFab color="secondary" aria-label="Example icon button with a menu icon">
              <mat-icon splUiIcon="menu-2"></mat-icon>
            </button>
            <button matMiniFab color="tertiary" aria-label="Example icon button with a menu icon">
              <mat-icon splUiIcon="menu-2"></mat-icon>
            </button>
            <button matMiniFab color="error" aria-label="Example icon button with a menu icon">
              <mat-icon splUiIcon="menu-2"></mat-icon>
            </button>
            <button matMiniFab disabled aria-label="Example icon button with a home icon">
              <mat-icon splUiIcon="home"></mat-icon>
            </button>
          </div>
        </div>
      </section>
      <mat-divider />
      <section>
        <div class="example-label">Extended Mini FAB</div>
        <div class="example-button-row">
          <div class="example-flex-container">
            <button matMiniFab extended aria-label="Example icon button with a menu icon">
              <mat-icon splUiIcon="menu-2"></mat-icon>
              Basic
            </button>
            <button matMiniFab extended color="primary" aria-label="Example icon button with a menu icon">
              <mat-icon splUiIcon="menu-2"></mat-icon>
              Primary
            </button>
            <button matMiniFab extended color="secondary" aria-label="Example icon button with a menu icon">
              <mat-icon splUiIcon="menu-2"></mat-icon>
              Secondary
            </button>
            <button matMiniFab extended color="tertiary" aria-label="Example icon button with a menu icon">
              <mat-icon splUiIcon="menu-2"></mat-icon>
              Tertiary
            </button>
            <button matMiniFab extended color="error" aria-label="Example icon button with a menu icon">
              <mat-icon splUiIcon="menu-2"></mat-icon>
              Error
            </button>
            <button matMiniFab extended disabled aria-label="Example icon button with a home icon">
              <mat-icon splUiIcon="home"></mat-icon>
              Disabled
            </button>
            <a matMiniFab extended routerLink=".">
              <mat-icon splUiIcon="external-link"></mat-icon>
              Link
            </a>
          </div>
        </div>
      </section>
    </mat-card-content>
  </mat-card>

  <mat-card class="preview-container__form-field">
    <mat-card-header>
      <mat-card-title>Form Field</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <section>
        <mat-form-field>
          <mat-label>Input</mat-label>
          <input matInput />
        </mat-form-field>
      </section>

      <section>
        <mat-form-field>
          <mat-label>Select</mat-label>
          <mat-select>
            <mat-option value="one">First option</mat-option>
            <mat-option value="two">Second option</mat-option>
          </mat-select>
        </mat-form-field>
      </section>

      <section>
        <mat-form-field>
          <mat-label>Textarea</mat-label>
          <textarea matInput></textarea>
        </mat-form-field>
      </section>

      <section>
        <mat-form-field>
          <mat-label>Choose a date</mat-label>
          <input matInput [matDatepicker]="formFieldPicker" />
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="formFieldPicker">
            <mat-icon matDatepickerToggleIcon splUiIcon="calendar-week-filled"></mat-icon
          ></mat-datepicker-toggle>
          <mat-datepicker #formFieldPicker></mat-datepicker>
        </mat-form-field>
      </section>

      <section>
        <form class="example-form">
          <mat-form-field class="example-full-width">
            <mat-label>Autocomplete</mat-label>
            <input
              type="text"
              placeholder="Pick some"
              aria-label="Number"
              matInput
              [formControl]="myControl"
              [matAutocomplete]="auto"
            />
            <mat-autocomplete #auto="matAutocomplete">
              @for (option of filteredOptions | async; track option) {
                <mat-option [value]="option">{{ option }}</mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </form>
      </section>
    </mat-card-content>
  </mat-card>

  <mat-card class="preview-container__checkbox">
    <mat-card-header>
      <mat-card-title>Checkbox</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <section class="example-section">
        <mat-checkbox class="example-margin">Check me!</mat-checkbox>
        <mat-checkbox class="example-margin" [disabled]="true">Disabled</mat-checkbox>
      </section>

      <section class="example-section">
        <span class="example-list-section">
          <mat-checkbox
            class="example-margin"
            [checked]="task().completed"
            [indeterminate]="partiallyComplete()"
            (change)="update($event.checked)"
          >
            {{ task().name }}
          </mat-checkbox>
        </span>
        <span class="example-list-section">
          <ul>
            @for (subtask of task().subtasks; track subtask; let i = $index) {
              <li>
                <mat-checkbox [checked]="subtask.completed" (change)="update($event.checked, i)">
                  {{ subtask.name }}
                </mat-checkbox>
              </li>
            }
          </ul>
        </span>
      </section>
    </mat-card-content>
  </mat-card>

  <mat-card class="preview-container__radio">
    <mat-card-header>
      <mat-card-title>Radio Button</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <mat-radio-group aria-label="Select an option">
        <mat-radio-button value="1" [checked]="true">Option 1</mat-radio-button>
        <mat-radio-button value="2">Option 2</mat-radio-button>
      </mat-radio-group>
    </mat-card-content>
  </mat-card>

  <mat-card class="preview-container__slide-toggle">
    <mat-card-header>
      <mat-card-title>Slide Toggle</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <section>
        <p><mat-slide-toggle>Slide me!</mat-slide-toggle></p>
        <p>
          <mat-slide-toggle labelPosition="before">...and slide me too!</mat-slide-toggle>
        </p>
      </section>
    </mat-card-content>
  </mat-card>

  <mat-card class="preview-container__dialog">
    <mat-card-header>
      <mat-card-title>Dialog</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <section>
        <button matButton (click)="openDialog()">Open dialog</button>
      </section>
    </mat-card-content>
  </mat-card>

  <mat-card class="preview-container__dialog">
    <mat-card-header>
      <mat-card-title>Tabs</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <section>
        <mat-tab-group>
          <mat-tab label="First"> Content 1 </mat-tab>
          <mat-tab label="Second"> Content 2 </mat-tab>
          <mat-tab label="Third"> Content 3 </mat-tab>
        </mat-tab-group>
      </section>
    </mat-card-content>
  </mat-card>

  <mat-card class="preview-container__snackbar">
    <mat-card-header>
      <mat-card-title>Snackbar</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <section>
        <button matButton="outlined" (click)="openSnackBar()" aria-label="Show an example snack-bar">
          Pool party!
        </button>
      </section>
    </mat-card-content>
  </mat-card>

  <mat-card class="preview-container__tooltip">
    <mat-card-header>
      <mat-card-title>Tooltip</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <section>
        <button
          matButton="elevated"
          matTooltip="Info about the action"
          aria-label="Button that displays a tooltip when focused or hovered over"
        >
          Action
        </button>
      </section>
    </mat-card-content>
  </mat-card>

  <mat-card class="preview-container__loading-indicator">
    <mat-card-header>
      <mat-card-title>Loading indicator</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <section>
        <h3>Mat progress bar</h3>

        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </section>

      <section>
        <h3>Mat spinner</h3>

        <mat-spinner diameter="50"></mat-spinner>
      </section>

      <section>
        <h3>Spl spinner</h3>

        <spl-ui-spinner diameter="50"></spl-ui-spinner>
      </section>
    </mat-card-content>
  </mat-card>

  <mat-card class="preview-container__paginator">
    <mat-card-header>
      <mat-card-title>Paginator</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <section>
        <mat-paginator
          [length]="100"
          [pageSize]="10"
          [pageSizeOptions]="[5, 10, 25, 100]"
          showFirstLastButtons
          aria-label="Select page"
        ></mat-paginator>
      </section>
    </mat-card-content>
  </mat-card>

  <mat-card class="preview-container__menu">
    <mat-card-header>
      <mat-card-title>Menu</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <section>
        <h3>Basic menu</h3>

        <button matButton [matMenuTriggerFor]="basicMenu">Menu</button>
        <mat-menu #basicMenu="matMenu">
          <button mat-menu-item>Item 1</button>
          <button mat-menu-item>Item 2</button>
        </mat-menu>
      </section>

      <section>
        <h3>Menu with icons</h3>

        <button matIconButton [matMenuTriggerFor]="iconsMenu" aria-label="Example icon-button with a menu">
          <mat-icon splUiIcon="dots-vertical"></mat-icon>
        </button>
        <mat-menu #iconsMenu="matMenu">
          <button mat-menu-item>
            <mat-icon splUiIcon="dialpad"></mat-icon>
            <span>Redial</span>
          </button>
          <button mat-menu-item disabled>
            <mat-icon splUiIcon="record-mail"></mat-icon>
            <span>Check voice mail</span>
          </button>
          <button mat-menu-item>
            <mat-icon splUiIcon="bell-x"></mat-icon>
            <span>Disable alerts</span>
          </button>
        </mat-menu>
      </section>

      <section>
        <h3>Nested menu</h3>

        <button matButton [matMenuTriggerFor]="nestedMenu">Animal index</button>
        <mat-menu #nestedMenu="matMenu">
          <button mat-menu-item [matMenuTriggerFor]="vertebrates">Vertebrates</button>
          <button mat-menu-item [matMenuTriggerFor]="invertebrates">Invertebrates</button>
        </mat-menu>

        <mat-menu #vertebrates="matMenu">
          <button mat-menu-item [matMenuTriggerFor]="fish">Fishes</button>
          <button mat-menu-item [matMenuTriggerFor]="amphibians">Amphibians</button>
          <button mat-menu-item [matMenuTriggerFor]="reptiles">Reptiles</button>
          <button mat-menu-item>Birds</button>
          <button mat-menu-item>Mammals</button>
        </mat-menu>

        <mat-menu #invertebrates="matMenu">
          <button mat-menu-item>Insects</button>
          <button mat-menu-item>Molluscs</button>
          <button mat-menu-item>Crustaceans</button>
          <button mat-menu-item>Corals</button>
          <button mat-menu-item>Arachnids</button>
          <button mat-menu-item>Velvet worms</button>
          <button mat-menu-item>Horseshoe crabs</button>
        </mat-menu>

        <mat-menu #fish="matMenu">
          <button mat-menu-item>Baikal oilfish</button>
          <button mat-menu-item>Bala shark</button>
          <button mat-menu-item>Ballan wrasse</button>
          <button mat-menu-item>Bamboo shark</button>
          <button mat-menu-item>Banded killifish</button>
        </mat-menu>

        <mat-menu #amphibians="matMenu">
          <button mat-menu-item>Sonoran desert toad</button>
          <button mat-menu-item>Western toad</button>
          <button mat-menu-item>Arroyo toad</button>
          <button mat-menu-item>Yosemite toad</button>
        </mat-menu>

        <mat-menu #reptiles="matMenu">
          <button mat-menu-item>Banded Day Gecko</button>
          <button mat-menu-item>Banded Gila Monster</button>
          <button mat-menu-item>Black Tree Monitor</button>
          <button mat-menu-item>Blue Spiny Lizard</button>
          <button mat-menu-item disabled>Velociraptor</button>
        </mat-menu>
      </section>
    </mat-card-content>
  </mat-card>

  <mat-card class="preview-container__badge">
    <mat-card-header>
      <mat-card-title>Badge</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <section>
        <h3>Spl badge (<i>text</i>)</h3>
        <spl-ui-badge>Text badge</spl-ui-badge>

        <h3>Spl badge (<i>numeric</i>)</h3>
        <spl-ui-badge>5</spl-ui-badge>
      </section>
    </mat-card-content>
  </mat-card>

  <mat-card class="preview-container__expansion">
    <mat-card-header>
      <mat-card-title>Expansion</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <section>
        <h3>Expansion steps</h3>

        <mat-accordion class="example-headers-align">
          <mat-expansion-panel [expanded]="step() === 0" (opened)="setStep(0)" hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title> Personal data </mat-panel-title>
              <mat-panel-description>
                Type your name and age
                <mat-icon splUiIcon="user-circle"></mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-form-field>
              <mat-label>First name</mat-label>
              <input matInput />
            </mat-form-field>

            <mat-form-field>
              <mat-label>Age</mat-label>
              <input matInput type="number" min="1" />
            </mat-form-field>
            <mat-action-row>
              <button matButton (click)="nextStep()">Next</button>
            </mat-action-row>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="step() === 1" (opened)="setStep(1)" hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title> Destination </mat-panel-title>
              <mat-panel-description>
                Type the country name
                <mat-icon splUiIcon="map"></mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-form-field>
              <mat-label>Country</mat-label>
              <input matInput />
            </mat-form-field>

            <mat-action-row>
              <button matButton (click)="prevStep()">Previous</button>
              <button matButton (click)="nextStep()">Next</button>
            </mat-action-row>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="step() === 2" (opened)="setStep(2)" hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title> Day of the trip </mat-panel-title>
              <mat-panel-description>
                Inform the date you wish to travel
                <mat-icon splUiIcon="calendar"></mat-icon>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <mat-form-field>
              <mat-label>Date</mat-label>
              <input matInput [matDatepicker]="expansionPicker" (focus)="expansionPicker.open()" readonly />
            </mat-form-field>
            <mat-datepicker #expansionPicker></mat-datepicker>

            <mat-action-row>
              <button matButton (click)="prevStep()">Previous</button>
              <button matButton (click)="nextStep()">End</button>
            </mat-action-row>
          </mat-expansion-panel>
        </mat-accordion>
      </section>

      <section>
        <h3>Single panel (with toggle)</h3>
        <mat-expansion-panel hideToggle>
          <mat-expansion-panel-header>
            <mat-panel-title> This is the expansion title </mat-panel-title>
            <mat-panel-description> This is a summary of the content </mat-panel-description>
          </mat-expansion-panel-header>
          <p>This is the primary content of the panel.</p>
        </mat-expansion-panel>

        <h3>Single panel (without toggle)</h3>

        <mat-expansion-panel #selfAwarePanel>
          <mat-expansion-panel-header>
            <mat-panel-title> Self aware panel </mat-panel-title>
            <mat-panel-description>
              Currently I am {{ selfAwarePanel.expanded ? 'opened' : 'closed' }}
            </mat-panel-description>
          </mat-expansion-panel-header>
          <p>I'm visible because I am opened</p>
        </mat-expansion-panel>
      </section>
    </mat-card-content>
  </mat-card>
</div>
